function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_14570_2263)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.703125 0.979492H17.6799V10.1485L16.8396 11.4621L17.6799 12.6312V17.9645H0.703125V9.32092L1.22831 8.71666L0.703125 8.13867V0.979492Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.99805 12.8153V10.1487H6.82015L7.12293 10.5436L7.43572 10.1487H17.6792V12.6314C17.6792 12.6314 17.4114 12.8126 17.1015 12.8153H11.4295L11.0881 12.395V12.8153H9.96946V12.0978C9.96946 12.0978 9.81665 12.1979 9.48628 12.1979H9.10552V12.8153H7.41178L7.10943 12.4119L6.80244 12.8153H3.99805Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.703125 8.1388L1.33952 6.65442H2.4401L2.80126 7.48591V6.65442H4.16938L4.38438 7.25539L4.59281 6.65442H10.7343V6.95655C10.7343 6.95655 11.0571 6.65442 11.5877 6.65442L13.5804 6.66139L13.9353 7.48199V6.65442H15.0802L15.3953 7.12579V6.65442H16.5507V9.32105H15.3953L15.0933 8.84815V9.32105H13.4112L13.242 8.90069H12.7898L12.6234 9.32105H11.4826C11.0261 9.32105 10.7343 9.02508 10.7343 9.02508V9.32105H9.01425L8.67288 8.90069V9.32105H2.27705L2.10801 8.90069H1.65724L1.48939 9.32105H0.703125V8.1388Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.56734 6.98328L0.708984 8.97996H1.26782L1.4262 8.58014H2.34692L2.50448 8.97996H3.07562L2.21808 6.98328H1.56734ZM1.88492 7.44797L2.16557 8.14664H1.60345L1.88492 7.44797Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.13281 8.97948V6.98279L3.92695 6.98574L4.38884 8.27308L4.83968 6.98279H5.62746V8.97948H5.12853V7.50823L4.59966 8.97948H4.16209L3.63174 7.50823V8.97948H3.13281Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.96875 8.97948V6.98279H7.59684V7.42942H6.47293V7.77095H7.57058V8.19131H6.47293V8.54599H7.59684V8.97948H5.96875Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.88477 6.98328V8.97996H8.3837V8.27061H8.59377L9.192 8.97996H9.80171L9.14522 8.24434C9.41465 8.2216 9.69257 7.99024 9.69257 7.63105C9.69257 7.21088 9.36294 6.98328 8.99505 6.98328H7.88477ZM8.3837 7.4299H8.95402C9.09083 7.4299 9.19035 7.53697 9.19035 7.64008C9.19035 7.77273 9.06141 7.85026 8.96141 7.85026H8.3837V7.4299Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4079 8.97948H9.89844V6.98279H10.4079V8.97948Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6135 8.97948H11.5035C10.9715 8.97948 10.6484 8.56011 10.6484 7.98934C10.6484 7.40448 10.9679 6.98279 11.6397 6.98279H12.1912V7.45569H11.6196C11.3468 7.45569 11.1539 7.66864 11.1539 7.99427C11.1539 8.38095 11.3745 8.54336 11.6923 8.54336H11.8235L11.6135 8.97948Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6982 6.98328L11.8398 8.97996H12.3987L12.5571 8.58014H13.4778L13.6353 8.97996H14.2065L13.3489 6.98328H12.6982ZM13.0158 7.44797L13.2964 8.14664H12.7343L13.0158 7.44797Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2676 8.97948V6.98279H14.9019L15.7119 8.23729V6.98279H16.2108V8.97948H15.597L14.7665 7.69214V8.97948H14.2676Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.33984 12.4739V10.4772H5.96793V10.9238H4.84403V11.2653H5.94167V11.6857H4.84403V12.0404H5.96793V12.4739H4.33984Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3184 12.4739V10.4772H13.9464V10.9238H12.8225V11.2653H13.9149V11.6857H12.8225V12.0404H13.9464V12.4739H12.3184Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.03255 12.4739L6.82525 11.4878L6.01367 10.4772H6.64226L7.1256 11.102L7.61058 10.4772H8.21455L7.41363 11.4755L8.2078 12.4739H7.57931L7.11001 11.8589L6.65211 12.4739H6.03255Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.26562 10.4773V12.474H8.77769V11.8435H9.30287C9.74726 11.8435 10.0841 11.6076 10.0841 11.1489C10.0841 10.7689 9.81991 10.4773 9.3677 10.4773H8.26562ZM8.77769 10.9288H9.33078C9.47434 10.9288 9.57696 11.0169 9.57696 11.1587C9.57696 11.292 9.47486 11.3886 9.32913 11.3886H8.77769V10.9288Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3008 10.4772V12.4739H10.7997V11.7645H11.0098L11.608 12.4739H12.2177L11.5612 11.7382C11.8307 11.7155 12.1086 11.4841 12.1086 11.1249C12.1086 10.7048 11.779 10.4772 11.4111 10.4772H10.3008ZM10.7997 10.9238H11.37C11.5068 10.9238 11.6064 11.0309 11.6064 11.134C11.6064 11.2666 11.4774 11.3442 11.3774 11.3442H10.7997V10.9238Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1766 12.4739V12.0404H15.1752C15.3229 12.0404 15.3869 11.9605 15.3869 11.8729C15.3869 11.7889 15.3231 11.7041 15.1752 11.7041H14.7239C14.3317 11.7041 14.1133 11.465 14.1133 11.1061C14.1133 10.7859 14.3133 10.4772 14.8961 10.4772H15.8677L15.6577 10.9264H14.8174C14.6567 10.9264 14.6073 11.0108 14.6073 11.0913C14.6073 11.1741 14.6684 11.2653 14.7911 11.2653H15.2638C15.701 11.2653 15.8907 11.5135 15.8907 11.8384C15.8907 12.1877 15.6793 12.4739 15.24 12.4739H14.1766Z",
  fill: "#016FD0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0087 12.4739V12.0404H17.0072C17.1549 12.0404 17.2189 11.9605 17.2189 11.8729C17.2189 11.7889 17.1551 11.7041 17.0072 11.7041H16.556C16.1637 11.7041 15.9453 11.465 15.9453 11.1061C15.9453 10.7859 16.1453 10.4772 16.7282 10.4772H17.6998L17.4897 10.9264H16.6494C16.4888 10.9264 16.4393 11.0108 16.4393 11.0913C16.4393 11.1741 16.5004 11.2653 16.6231 11.2653H17.0958C17.533 11.2653 17.7228 11.5135 17.7228 11.8384C17.7228 12.1877 17.5113 12.4739 17.072 12.4739H16.0087Z",
  fill: "#016FD0"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14570_2263"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.019,
  height: 16.985,
  fill: "white",
  transform: "translate(0.701172 0.979736)"
})));
const SvgAmericanExpress = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAmericanExpress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/american-express.19f75fec.svg";
export { ForwardRef as ReactComponent };